import type { CustomFieldValue, ProjectNode } from '@/shared/types/projectData';

type LegacyProjectNode = ProjectNode & {
  custom_fields?: Record<string, unknown>;
};

/** Preserve unrelated fields, but emit one name for each editor-owned field. */
export const getNodeCustomFields = (node: ProjectNode | null | undefined): Record<string, CustomFieldValue> => {
  const fields = {
    ...((node as LegacyProjectNode | null | undefined)?.custom_fields as Record<string, CustomFieldValue> | undefined),
    ...node?.customFields,
  };
  for (const [camelKey, snakeKey] of [
    ['blockDocument', 'block_document'],
    ['printLayoutSettings', 'print_layout_settings'],
    ['printLayout', 'print_layout'],
  ]) {
    const value = getNodeCustomField(node, camelKey, snakeKey);
    delete fields[camelKey];
    delete fields[snakeKey];
    if (value !== undefined) fields[camelKey] = value as CustomFieldValue;
  }
  return fields;
};

export const getNodeCustomField = (
  node: ProjectNode | null | undefined,
  camelKey: string,
  snakeKey: string,
): unknown => {
  if (!node) {
    return undefined;
  }

  if (node.customFields) {
    if (camelKey in node.customFields) {
      return node.customFields[camelKey];
    }
    if (snakeKey in node.customFields) {
      return node.customFields[snakeKey];
    }
  }

  const legacyNode = node as LegacyProjectNode;
  if (legacyNode.custom_fields) {
    if (camelKey in legacyNode.custom_fields) {
      return legacyNode.custom_fields[camelKey];
    }
    if (snakeKey in legacyNode.custom_fields) {
      return legacyNode.custom_fields[snakeKey];
    }
  }

  return undefined;
};
